var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_10130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4219 0H17.5781C7.86999 0 0 7.86999 0 17.5781V42.4219C0 52.13 7.86999 60 17.5781 60H42.4219C52.13 60 60 52.13 60 42.4219V17.5781C60 7.86999 52.13 0 42.4219 0Z",
    fill: "#BAD7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9144 34.1543L45.6577 32.2734C45.7644 31.5305 45.8206 30.7723 45.8206 30C45.8206 29.2277 45.7644 28.4684 45.6577 27.7266L48.9144 25.8457C50.3159 25.0371 50.7952 23.2453 49.9866 21.8437L47.057 16.7695C46.2484 15.368 44.4566 14.8887 43.055 15.6973L39.7972 17.5781C38.6101 16.6406 37.2859 15.8707 35.8597 15.3012V11.543C35.8597 9.92461 34.5484 8.61328 32.93 8.61328H27.0706C25.4523 8.61328 24.1409 9.92461 24.1409 11.543V15.3012C22.7256 15.8665 21.3994 16.6334 20.2034 17.5781L16.9456 15.6973C15.5441 14.8887 13.7523 15.368 12.9437 16.7695L10.014 21.8437C9.2054 23.2453 9.68469 25.0371 11.0863 25.8457L14.3429 27.7266C14.2363 28.4695 14.18 29.2277 14.18 30C14.18 30.7723 14.2363 31.5316 14.3429 32.2734L11.0863 34.1543C9.68469 34.9629 9.2054 36.7547 10.014 38.1563L12.9437 43.2305C13.7523 44.632 15.5441 45.1113 16.9456 44.3027L20.2034 42.4219C21.3906 43.3594 22.7148 44.1293 24.1409 44.6988V48.457C24.1409 50.0754 25.4523 51.3867 27.0706 51.3867H32.93C34.5484 51.3867 35.8597 50.0754 35.8597 48.457V44.6988C37.275 44.1335 38.6012 43.3666 39.7972 42.4219L43.055 44.3027C44.4566 45.1113 46.2484 44.632 47.057 43.2305L49.9866 38.1563C50.7952 36.7547 50.3159 34.9629 48.9144 34.1543ZM30.0003 37.0312C26.1167 37.0312 22.9691 33.8836 22.9691 30C22.9691 26.1164 26.1167 22.9688 30.0003 22.9688C33.8839 22.9688 37.0316 26.1164 37.0316 30C37.0316 33.8836 33.8839 37.0312 30.0003 37.0312Z",
    fill: "#4B84DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_10130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.da5d6ef50d8382ae1e878c669fc2ade4.svg";
export { ForwardRef as ReactComponent };